"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Routers_1 = require("@twii/router/lib/Routers");
var DefaultReactRouterOptions = {
    exact: true,
    allowTrailingSlash: false,
    requestPropKey: "match"
};
exports.DefaultReactRouterOptions = DefaultReactRouterOptions;
var reactRouter = function (importer, opts) {
    var mergedOpts = Object.assign({}, DefaultReactRouterOptions, opts);
    var handler = function (request) {
        return Promise.resolve(importer()).then(function (m) {
            var type = mergedOpts.exportKey ? m[mergedOpts.exportKey] : m.default;
            if (!type) {
                throw { code: "ILLEGAL_ARGUMENT", message: "Unable to resolve React Component Type" };
            }
            var props = {};
            props[mergedOpts.requestPropKey] = request;
            return React.createElement(type, props);
        });
    };
    return mergedOpts.exact ? Routers_1.exactPath(handler, mergedOpts) : handler;
};
exports.reactRouter = reactRouter;
exports.default = reactRouter;
